import { useMemo } from 'react';
import {
  FieldType,
  MultiSelectField,
  SourceType,
} from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';

//
// const computePhases = (
//   projects: Project[],
//   oldPhaseOptions: FieldOptionBase<number>[],
// ) => {
//   const oldComputedPhaseNames = Object.values(oldPhaseOptions).map(
//     (option) => option.label,
//   );
//   const computedPhases: Record<string, FieldOptionBase<number>> = {};
//   let shouldUpdate = false;

//   projects?.forEach((project) => {
//     project?.projectPhases?.forEach((phase) => {
//       if (!phase) {
//         return;
//       }
//       if (!oldComputedPhaseNames.includes(phase.projectPhaseName)) {
//         shouldUpdate = true;
//       }
//       computedPhases[phase.projectPhaseName] = {
//         label: phase.projectPhaseName,
//         value: phase.projectPhaseName,
//         color: getRandomColor(phase.projectPhaseId),
//         active: true,
//       } as unknown as FieldOptionBase;
//     });
//   });

//   if (shouldUpdate) {
//     return Object.values(computedPhases).sort((a, b) =>
//       sortByText(a.label, b.label),
//     );
//   }

//   return oldPhaseOptions;
// };

export const useCurrentPhasesField = (
  fieldId: number,
): {
  currentPhasesField: MultiSelectField;
  isLoading: boolean;
} => {
  const fieldLabel = useTranslation('project.fields.current_phases');

  return useMemo(
    () => ({
      currentPhasesField: {
        fieldId,
        fieldName: 'currentPhases',
        fieldLabel,
        type: FieldType.MultiSelect,
        private: false,
        userCreated: false,
        metaData: {
          options: [],
        },
        sourceType: SourceType.Project,
      },
      isLoading: false,
    }),
    [fieldId, fieldLabel],
  );
};
